import { contactData } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3">{contactData.title}</h2>
          <p className="text-sm md:text-base text-foreground-600 mb-8">{contactData.description}</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-lg mx-auto">
            <div className="rounded-xl bg-background-100 border border-background-200/60 p-5 text-center">
              <div className="w-10 h-10 rounded-full bg-primary-500/15 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-primary-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">电子邮箱</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.email}</div>
            </div>

            <div className="rounded-xl bg-background-100 border border-background-200/60 p-5 text-center">
              <div className="w-10 h-10 rounded-full bg-accent-500/15 flex items-center justify-center mx-auto mb-3">
                <i className="ri-wechat-line text-accent-500 text-lg w-5 h-5 flex items-center justify-center"></i>
              </div>
              <div className="text-xs text-foreground-500 mb-1">微信公众号</div>
              <div className="text-sm font-medium text-foreground-800">{contactData.wechat}</div>
            </div>
          </div>

          <p className="text-xs text-foreground-500 mt-6">{contactData.tips}</p>
        </div>
      </div>
    </section>
  );
}